import { createBrowserRouter } from "react-router";
import AdminRoute from "../components/admin-route/admin-route";
import PrivateRoute from "../components/private-route/private-route";
import Admin from "../screens/admin/admin";
import AuthorProfile from "../screens/author-profile/author-profile";
import BroadcastPortal from "../screens/broadcast-portal/broadcast-portal";
import BroadcastStats from "../screens/broadcast-stats/broadcast-stats";
import Home from "../screens/home/home";
import Login from "../screens/login/login";
import NewBroadcast from "../screens/new-broadcast/new-broadcast";
import Register from "../screens/register/register";
import Settings from "../screens/settings/settings";
import ViewerFeed from "../screens/viewer-feed/viewer-feed";

export const router = createBrowserRouter([
	{ path: "/", element: <Home /> },
	{ path: "/login", element: <Login /> },
	{ path: "/author/:uid", element: <AuthorProfile /> },
	{ path: "/broadcast/:id/stats", element: <BroadcastStats /> },
	{ path: "/register", element: <Register /> },
	{ path: "/broadcast/:id", element: <ViewerFeed /> },
	{
		path: "/new",
		element: (
			<PrivateRoute>
				<NewBroadcast />
			</PrivateRoute>
		),
	},
	{
		path: "/broadcast",
		element: (
			<PrivateRoute>
				<BroadcastPortal />
			</PrivateRoute>
		),
	},
	{
		path: "/settings",
		element: (
			<PrivateRoute>
				<Settings />
			</PrivateRoute>
		),
	},
	{
		path: "/admin",
		element: (
			<AdminRoute>
				<Admin />
			</AdminRoute>
		),
	},
]);
